import React from 'react';
import ClassAssembly  from 'views/ClassAssembly6A';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;